<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="教室管理" name="clasRroom">
        <classRoomManage />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import classRoomManage from "./classRoomManage/index.vue";
export default {
  components: {
    classRoomManage,
  },
  data() {
    return {
      activeName: "clasRroom",
    };
  },
};
</script>
<style scoped lang="scss">
.container {
  padding: 0 12px 12px 12px;
  border-radius: 4px;
  position: relative;
  height: calc(100% - 34px);
  background: #fff;
}
/deep/ .el-tabs__active-bar {
  width: 50px !important;
}
</style>
